var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgApplePay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 88,
    viewBox: "0 0 110 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_126_1073)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 20.0001,
    width: 70,
    height: 48,
    rx: 15.875,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M36.6925 37.8662C37.6326 37.9455 38.5727 37.3904 39.1602 36.6866C39.738 35.9629 40.1199 34.9915 40.022 34.0002C39.1896 34.0399 38.1614 34.5553 37.5738 35.279C37.0352 35.9035 36.575 36.9145 36.6925 37.8662ZM47.8749 50.6335V35.1798H53.6035C56.5608 35.1798 58.6271 37.2416 58.6271 40.255C58.6271 43.2684 56.5217 45.3501 53.5252 45.3501H50.2447V50.6335H47.8749ZM40.012 38.0546C39.1838 38.0063 38.4281 38.3067 37.8177 38.5493C37.4249 38.7054 37.0923 38.8377 36.8392 38.8377C36.5552 38.8377 36.2089 38.6984 35.82 38.542C35.3104 38.3371 34.7278 38.1028 34.1169 38.114C32.7166 38.1339 31.4142 38.9368 30.6993 40.2155C29.2304 42.773 30.3174 46.5596 31.7373 48.6412C32.4326 49.6721 33.265 50.8022 34.3617 50.7625C34.8442 50.7441 35.1913 50.595 35.5505 50.4407C35.9641 50.2631 36.3937 50.0785 37.0645 50.0785C37.712 50.0785 38.1228 50.2583 38.5172 50.4308C38.8921 50.5948 39.2522 50.7524 39.7868 50.7427C40.9227 50.7229 41.6376 49.7118 42.3328 48.6809C43.0831 47.5744 43.4129 46.4946 43.4629 46.3307L43.4688 46.3118C43.4676 46.3105 43.4583 46.3063 43.4419 46.2987C43.1911 46.1824 41.274 45.294 41.2557 42.9117C41.2372 40.9122 42.7762 39.899 43.0185 39.7395C43.0332 39.7298 43.0432 39.7233 43.0477 39.7199C42.0684 38.2528 40.5408 38.0942 40.012 38.0546ZM62.956 50.7526C64.4445 50.7526 65.8252 49.9893 66.4519 48.78H66.5009V50.6337H68.6944V42.9415C68.6944 40.7112 66.9318 39.2738 64.2192 39.2738C61.7026 39.2738 59.842 40.731 59.7734 42.7333H61.9082C62.0845 41.7817 62.956 41.1572 64.1507 41.1572C65.6 41.1572 66.4128 41.8412 66.4128 43.1001V43.9526L63.4554 44.131C60.7037 44.2995 59.2153 45.4395 59.2153 47.422C59.2153 49.4243 60.7527 50.7526 62.956 50.7526ZM63.5914 48.9188C62.3282 48.9188 61.5252 48.3042 61.5252 47.3625C61.5252 46.3911 62.2988 45.8261 63.7775 45.7368L66.4117 45.5683V46.4406C66.4117 47.8879 65.1974 48.9188 63.5914 48.9188ZM75.9705 51.2382C75.0206 53.9443 73.9337 54.8365 71.6226 54.8365C71.4464 54.8365 70.8588 54.8167 70.7217 54.777V52.9233C70.8686 52.9432 71.2309 52.963 71.417 52.963C72.4648 52.963 73.0523 52.5169 73.4146 51.3572L73.6301 50.6732L69.6152 39.4224H72.0927L74.8835 48.5519H74.9325L77.7234 39.4224H80.1323L75.9705 51.2382ZM50.2442 37.2019H52.9764C55.0328 37.2019 56.2079 38.3121 56.2079 40.2649C56.2079 42.2177 55.0328 43.3378 52.9666 43.3378H50.2442V37.2019Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_126_1073",
    x: 0,
    y: 0.00012207,
    width: 110,
    height: 88,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.07 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_126_1073"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_126_1073",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplePay);
export default __webpack_public_path__ + "static/media/apple-pay.cedbb6247baaae6a6b7f46c6f4405b3e.svg";
export { ForwardRef as ReactComponent };